(function($) {
  if (window.template == 'collection') {
  window.addEventListener("popstate", (event) => {     
      if (!mt._sidebarAjaxClick && !mt._linksClicked) {        
        mt._sidebarparams();
        var sortby = Shopify.queryParams.sort_by;
        if (!sortby) sortby = window.default_sort;
        $('#sort_by').val(sortby);
        var n = mt._sidebarcreateUrl();
        mt._sidebargetContent(n);
        mt._reactivesidebar();       
      }
      mt._sidebarAjaxClick = false;
      mt._linksClicked = false;
    })
  }
  
  if (window.use_color_swatch) {
    $(".swatch :radio").change(function() {
      var t = $(this).closest(".swatch").attr("data-option-index");
      var n = $(this).val();
      $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
    });
    Shopify.optionsMap = {};
    Shopify.updateOptionsInSelector = function(t) {
      switch (t) {
        case 0:
          var n = "root";
          var r = $(".single-option-selector:eq(0)");
          break;
        case 1:
          var n = $(".single-option-selector:eq(0)").val();
          var r = $(".single-option-selector:eq(1)");
          break;
        case 2:
          var n = $(".single-option-selector:eq(0)").val();
          n += " / " + $(".single-option-selector:eq(1)").val();
          var r = $(".single-option-selector:eq(2)")
          }
      var i = r.val();
      r.empty();
      var s = Shopify.optionsMap[n];
      // if (typeof s === 'undefined') return; //fix this in the future for color variants
      for (var o = 0; o < s.length; o++) {
        var u = s[o];
        var a = $("<option></option>").val(u).html(u);
        r.append(a)
      }
     
      $('.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr("data-value"), s) !== -1) {
          $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked")
        } else {
          $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }
      });
      if ($.inArray(i, s) !== -1) {
        r.val(i)
      }
      r.trigger("change")
    };
    
    Shopify.linkOptionSelectors = function(mt) {
      for (var n = 0; n < mt.variants.length; n++) {
        var r = mt.variants[n];
        if (r.available) {
          Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
          Shopify.optionsMap["root"].push(r.option1);
          Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
          if (mt.options.length > 1) {
            var i = r.option1;
            Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
            Shopify.optionsMap[i].push(r.option2);
            Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
          }
          if (mt.options.length === 3) {
            var i = r.option1 + " / " + r.option2;
            Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
            Shopify.optionsMap[i].push(r.option3);
            Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
          }
        }
      }
      Shopify.updateOptionsInSelector(0);
      if (mt.options.length > 1) Shopify.updateOptionsInSelector(1);
      if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
      $(".single-option-selector:eq(0)").change(function() {
        Shopify.updateOptionsInSelector(1);
        if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true
      });
      $(".single-option-selector:eq(1)").change(function() {
        if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true
      })
    }
  }
  
  function add_readmore(){
    var collapsableH = (window.template === "product") ? 40:18;
    var description = $('.description');
    var readmore = $('.readmore');
    var readless = $('.readless');
    readmore.show();
    readless.hide();
    readmore.click(function(e){
      e.preventDefault();
      description.css('height','auto');
      readmore.hide();
      readless.show();
    });
    readless.click(function(e){
      e.preventDefault();
      description.css('height',collapsableH + 'px');
      readless.hide();      
      readmore.show();
    });
  }
  

  window.addEventListener("pageshow", function(event){
    mt._updateheadercart();
  });

  $(document).ready(function() {
    mt.go();
    add_readmore();
  });
  
  var mt = {
    atTimeout: null,
    _sidebarAjaxClick: false,
    _linksClicked: false,
    go: function() {
      this._checkitemdropcart();
      this._sidebar();
      this._mesagebox();
      this._productaddtocart();
      this._colorswatchgridInit();
      this.close_box();
      this._openminicart();
      this._quantity_control();
      this._closeminicart();
      this._sidebarexpandcaret();     
    },
    _openminicart: function() {      
      $(".cartToggle").on('click touchend',function(n){
        if (!document.getElementById('your-shopping-bag')) {
      	n.preventDefault();
	    $('#dropdown-cart').addClass('active');
      	$('.wrapper-container, body').addClass('show-cart');
      	$('body,html').css( "overflow", "hidden" );
        }     
      })                         
        
    },
    _closeminicart: function() {      
      $(".continue-shoping a").click(function(n) {
      	n.preventDefault();
	    $('#dropdown-cart').removeClass('active');
      	$('.wrapper-container, body').removeClass('show-cart');
      	$('body,html').css( "overflow", "visible" );
      
      })                         
        
    },
    _colorswatchgridInit: function(){
      $('.color-swatch-item li a').on('click', function(e){
        e.preventDefault();  
        var productImage = $(this).parents('.product-inner').find('.grid-image'); 
        productImage.find('img.feature-images').attr('src', $(this).data('image'));  
      });
    },
    _ajaxsidebar: function() {
      $(".sidebar-tag a, .sidebar-tag li.ok-tag").click(function(n) {       
        if($(this).hasClass('clear-all') || $(this).hasClass('clear-single')) {
        	return true;
    	}
        
        var $inPut =  $(this).find("input");
        
        if ($inPut) {
          var $inPutParent = $inPut.parent('li');
          if ($inPut.is(':checked')) {
            $inPut.prop( 'checked', false );
            $inPutParent.removeClass('checked');
          }
          else {
            $inPut.prop( 'checked', true );
            $inPutParent.addClass('checked');
          }
        }
        
        var r = [];
        if (Shopify.queryParams.constraint) {
          r = Shopify.queryParams.constraint.split("+")
        }
        if (!window.enable_sidebar_multiple_choice && !$(this).children('input').eq(0).is(":checked")) {         
          var i = $(this).find("input:checked");
          if (i.length > 0) {
            var s = i.val();
            if (s) {
              var o = r.indexOf(s);
              if (o >= 0) {
                r.splice(o, 1)
              }
            }
          }
        }
        var s = $(this).children('input').eq(0).val();
        if (s) {
          var o = r.indexOf(s);
          if (o >= 0) {
            r.splice(o, 1)
          } else {
            r.push(s)
          }
        }
        if (r.length) {
          Shopify.queryParams.constraint = r.join("+")
        } else {
          delete Shopify.queryParams.constraint
        }
        mt.sidebarAjaxClick();
        n.preventDefault()
      })
    },
    _checkitemdropcart: function() {
      if ($("#dropdown-cart .cart-list").children().length > 0) {
        $("#dropdown-cart .cart-empty").hide();
        $("#dropdown-cart .mini_cart_header").addClass("active");
      } else {
        $("#dropdown-cart .mini_cart_header").removeClass("active");
        $("#dropdown-cart .cart-empty").show()
      }
    },
    _accordionsibar: function() {
      if ($(".sidebar-tag").length > 0) {
        $(".sidebar-tag .widget-title span").click(function() {
          var cart = $(this).parents(".widget-title");
          if (mt.hasClass("click")) {
            mt.removeClass("click")
          } else {
            mt.addClass("click")
          }
          $(this).parents(".sidebar-tag").find(".widget-content").slideToggle()
        })
      }
    },
    _sidebarexpandcaret: function() {
      $(".sidebar-custom.sidebar-tag .title").click(function() {
        var widget_content =  $(this).parent().find(".widget-content");
        var widget_icon = $(this).find('.novetty_icon');
                                                                
        if (widget_content.is(":hidden")) {
          widget_content.slideDown(100);
          widget_icon.toggleClass('d-none');
        } else {
          widget_content.slideUp(100);
          widget_icon.toggleClass('d-none');
        }
      });
    },
    _clearsidebarall: function() {
      $('.addlabel a').on('click', function(e) {
        e.preventDefault();

        if($(this).hasClass('clear-all')) {
          delete Shopify.queryParams.constraint;
          delete Shopify.queryParams.q;         
        }
        else {
          var tag = $(this).data('filter-tag');
          if (Shopify.queryParams.constraint) {
            var params = Shopify.queryParams.constraint.split('+');
              params.splice(params.indexOf(tag), 1);
              Shopify.queryParams.constraint = params.join('+');  
              if (!Shopify.queryParams.constraint.length) delete Shopify.queryParams.constraint;
          }
        }
        mt.sidebarAjaxClick();
      });
      $(".filter_footer button.reset").on('click', function(e) {       
        $(this).prop('disabled', true);
        $('.addlabel a.clear-all').click();
        setTimeout(function() { 
         $(".filter_footer button.reset").prop('disabled', false);
        }, 1000);
       
      })
    },
    _evensidebar: function() {
      mt._ajaxsidebar();
      mt._collectionlinkajax();
      mt._collectionPagelinkajax();
      mt._collectionSortingajax();
      mt._colorswatchgridInit();
    },
    _reactivesidebar: function() {
      var n = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (n && n[1]) {
        $(".sidebar-links a[href='" + n[0] + "']").addClass("active");
      }
    },
    _collectionlinkajax: function() {
      $(".sidebar-links a").click(function(e) {
        var $this = $(this);
        if (!$this.hasClass("active")) {
          $(".sidebar-links a.active").removeClass("active");         
          $this.addClass("active");
          mt._collectionPageAjaxClick($this.attr("href"));
        }
 
        e.preventDefault();
      })
    },
    _collectionPagelinkajax: function() {
      $(".pagination-page li a").click(function(e) {
          mt._collectionPageAjaxClick($(this).attr("href")); 

          e.preventDefault();
      })
    },
    _collectionSortingajax: function() {
      $('.sort_by').on('change', function(e) {
          Shopify.queryParams.sort_by = $(this).val();        
          $('option:not(:selected)', this ).removeAttr('selected');
          $('option:selected', this ).attr('selected','');
         
          mt.sidebarAjaxClick(location.pathname); 

          e.preventDefault();
      })
    },
    _collectionPageAjaxClick: function(newurl) {
          if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
          }
          delete Shopify.queryParams.constraint;
          delete Shopify.queryParams.q;   
          delete Shopify.queryParams.view;
          mt._linksClicked = true;
          history.pushState(Shopify.queryParams.page, newurl, newurl);
          window.scrollTo({ top:0, left:0, behavior: "instant"});
          //update login hrefs
          $(".header-log-in").each(function() {
          	$(this)[0].search = 'redirect_url='+location.pathname+location.search;
          });
       
          mt._sidebargetContent(newurl);
    },
    sidebarMapData: function(n) {
      var rs = $(".col-main .products-grids");
      if (rs.length == 0) {
        rs = $(".col-main .product-list")
      }
      var is = $(n).find(".col-main .products-grids");
      if (is.length == 0) {
        is = $(n).find(".col-main .product-list")
      }
      var cart = $(".col-main .products-grid");
      if (cart.length == 0) {
        cart = $(".col-main .product-list")
      }
      var i = $(n).find(".col-main .products-grid");
      if (i.length == 0) {
        i = $(n).find(".col-main .product-list")
      }

      cart.replaceWith(i);
      rs.replaceWith(is);
      
      if ($(".col-main .padding").length > 0) {
        $(".filter-top-wr").replaceWith($(n).find(".filter-top-wr"));
        $(".col-main .padding").replaceWith($(n).find(".padding"));
        $(".showing").replaceWith($(n).find(".showing"));
        $(".description").replaceWith($(n).find(".description"));
        $(".breadcrumb_position").replaceWith($(n).find(".breadcrumb_position"));        
      } else {
        $(".col-main").append($(n).find(".padding"));
      }
      
      var s = $(".page-header");
      var o = $(n).find(".page-header");
      
      if (s.find("h2").text() != o.find("h2").text()) {
        s.find("h2").replaceWith(o.find("h2"));
        if (s.find(".rte").length) {
          if (o.find(".rte").length) {
            s.find(".rte").replaceWith(o.find(".rte"))
          } else {
            s.find(".rte").hide()
          }
        } else {
          if (o.find(".rte").length) {
            s.find("h2").after(o.find(".rte"))
          }
        }
      }
      
      $(".addlabel").replaceWith($(n).find(".addlabel"));
      $(".filter-top-wr").replaceWith($(n).find(".filter-top-wr"));
      $(".col-main .showing").replaceWith($(n).find(".showing"));
      $(".sidebar-block").replaceWith($(n).find(".sidebar-block"));
      $(".col-main .padding").replaceWith($(n).find(".padding"));
      $(".description").replaceWith($(n).find(".description"));
      $(".breadcrumb_position").replaceWith($(n).find(".breadcrumb_position"));     
      add_readmore();
      var mobile_view_cookie = lsStorage.cookie('mobileview');
      initButtons();
      initGrid();
       
      if (mobile_view_cookie) {
       $('#'+mobile_view_cookie+'_view_mode').click();
      } else {
       $('#list_view_mode').parent().addClass('active');
      }     
    },
    _sidebarcreateUrl: function(mt) {
      var n = $.param(Shopify.queryParams).replace(/%2B/g, "+");

      if (mt) {
        if (n != "") return mt + "?" + n;
        else return mt
          }
      return location.pathname + "?" + n;
    },
    sidebarAjaxClick: function(e) {      
      delete Shopify.queryParams.page;   
      var n = mt._sidebarcreateUrl(e);
      
      if (!Shopify.queryParams.constraint && !Shopify.queryParams.sort_by) {
        n = n.replace('?','');
      }
      
      mt._sidebarAjaxClick = true;
      
      history.pushState({
        param: Shopify.queryParams
      }, n, n);
      
      //clean up
      //if ($.isEmptyObject(Shopify.queryParams) || $.isEmptyObject(Shopify.queryParams.constraint)) {
       // history.replaceState && history.replaceState(
  			//null, '', location.pathname
        //);
      //}
       window.scrollTo({ top:0, left:0, behavior: "instant"});
      //update login hrefs
      $(".header-log-in").each(function() {
      	$(this)[0].search = 'redirect_url='+location.pathname+location.search;
      });

      mt._sidebargetContent(n);
    },
      
    _sidebargetContent: function(n) {
      var newURL = new URL(n,window.baseURL);
      newURL.searchParams.append('view', 'strip');      
      var fullURL = newURL.toString();
      //var relURL = fullURL.replace(baseURL,'');
      //localCache: true,      
      //cacheTTL: 0.10,  
      //cacheKey: relURL,

      $.ajax({
        type: "get",
        url: fullURL,
        beforeSend: function() {
          mt.showLoading();          
        },
        success: function(e) {
          mt.sidebarMapData(e);
          mt._ajaxsidebar();
          mt._accordionsibar();
          mt._clearsidebarall();
          mt.hideLoading();
          mt._colorswatchgridInit();
          mt._collectionlinkajax();
          mt._collectionPagelinkajax();
          mt._sidebarexpandcaret();
       
          if (mt._checkcurrency()) {
            if(typeof Currency != 'undefined') {
               $('.product-item span.money').each(function() {
                  $(this).attr('data-currency-'+window.shop_currency, $(this).html());
               });
               Currency.convertAll(window.shop_currency, $('.currencies_ul .currency.selected').data('currency'))
            }
          }
           mt._sidebarAjaxClick = false;
           mt._linksClicked = false;
         
        },
        error: function(e) {
          mt.hideLoading();          
          mt._sidebarAjaxClick = false;
          mt._linksClicked = false;;         
          location.reload();          
          //localStorage.removeItem(n);
        }
      })
    },
    _sidebarparams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var e, mt = 0, n = location.search.substr(1).split("&"); mt < n.length; mt++) {
          e = n[mt].split("=");
          if ($.length > 1) {
            Shopify.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1])
          }
        }
      }     
    },
    _sidebar: function() {
      if ($("#filter-sidebar").length > 0) {
        mt._sidebarparams();
        mt._evensidebar();
        mt._accordionsibar();
        mt._clearsidebarall();
        mt._colorswatchgridInit();
      }
    },
    close_box: function(){
      $('.close-box').click(function(){
        $('.wrapper-container, body').removeClass('show-carts');
        $(".ajax-success-cbox").removeClass('popit');
      });
      $('.ajax-success-cbox').click(function(e){
        if(e.target != this) return;
        $('.wrapper-container, body').removeClass('show-carts');
        $(".ajax-success-cbox").removeClass('popit');
      });
    },
    showBox: function(n) {
      var box = $(n);
      box.fadeIn(300);
      mt.atTimeout = setTimeout(function() {
        box.fadeOut(300);
      }, 4e3);
      box.click(function(){
        clearTimeout(mt.atTimeout);
        box.fadeOut(100);
      });
    },
    _mesagebox: function() {
      $(".continue-shopping").click(function() {
        clearTimeout(mt.atTimeout);
        $(".ajax-success-cbox").fadeOut(500)
      });
      $(".close-cbox").click(function() {
        clearTimeout(mt.atTimeout);
        $(".ajax-success-cbox").fadeOut(500)
      })
    },
    _productaddtocart: function() {
      if (window.template != 'product' && window.template != 'collection') return;
      $('#product-add-to-cart, .product-feed-add-to-cart[name="add"]').click(function(e) {
      	e.preventDefault();
      	if (!this.disabled && !this.classList.contains('disable')) {
          var form = this.closest('.shopify-product-form');
          var form_inputs = form.querySelectorAll("[name]");
          var form_data = formToJSON(form_inputs);
          mt._ajaxaddtocart(form_data, $(this));
      	}
      	return false
      })
    },
    showLoading: function() {
      $("#loading").show()
    },
    hideLoading: function() {
      $("#loading").hide()
    },
    _ajaxaddtocart: function(form_data, cartButton) {
      var drawerCart = $('#dropdown-cart');
      
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: form_data,
        dataType: "json",
        beforeSend: function() {         
          drawerCart.addClass('loading');
          cartButton.addClass("btn-loading").html('<svg class="icon-svg-spinner qb-spinne" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2z"></path></svg>');
          cartButton.addClass('active').prop('disabled', true);
        },
        success: function(n) {
          mt._updateheadercart();
          drawerCart.addClass('active');
      	  $('.wrapper-container, body').addClass('show-cart');
      	  $('body, html').css( "overflow", "hidden" );
          cartButton.removeClass("btn-loading").removeClass('active').prop('disabled', false).html('<span>Add to Bag</span>');
          drawerCart.removeClass('loading');
         },
        error: function(n, r) {
          var response = $.parseJSON(n.responseText);
          var message = response.description;
         
          if (typeof(response.description) === 'object') { 
            message = response.message;
            message = message.replace('Email Email','Email');
            message = message.replace('Name Name','Name');
            message = message.replace('Message Message','Message');
            message = message.replace('Send on Send on','Send on');
          }
          
          drawerCart.removeClass('active, loading');
          cartButton.removeClass("btn-loading").removeClass('active').prop('disabled', false).html('<span>Add to Bag</span>');
          $(".ajax-error-message").text(message);
          mt.showBox(".ajax-error-cbox");
        }
      })
    },
    _updateheadercart: function() {
      Shopify.getCart(function(e) {    
        mt._headercartitem(e);
      })
    },
    _headercartitem: function(n) {
      var cart = '<li class="item" id="cart-item-{ID}" data-key="{KEY}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-inner"><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="option"><span class="variant_title">{VARIANCE}</span>{GC_DETAILS}</div><div class="cart-collateral"><div class="qty-cart"><div class="qty-wrap"><div class="qty-label">Qty: </div><div class="qty-minus plusminus">–</div><div class="cur_quantity">{QUANTITY}</div><div class="qty-plus plusminus">+</div></div></div></div><div class="item_total_price">{TOTALPRICE}</div><a href="javascript:void(0)" title="Remove Item" class="btn-remove">Remove</a></div></li>';
      //var cart = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-inner"><a href="javascript:void(0)" title="Remove Item" class="btn-remove"><i class="cs-font clever-icon-close"></i></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral"><span class="price">{PRICE}</span>Qty:  {QUANTITY}</div></div></li>';

      $(".cart-count").text(n.item_count);
      $("#dropdown-cart .cart-list").html("");
      $(".summary .price").html(Shopify.formatMoney(n.total_price, window.money_format));
         
      if (n.item_count > 0) {
        for (var i = 0; i < n.items.length; i++) {
          var s = cart;
          s = s.replace(/\{ID\}/g, n.items[i].id);
          s = s.replace(/\{URL\}/g, n.items[i].url);
          s = s.replace(/\{TITLE\}/g, n.items[i].product_title);
          s = s.replace(/\{QUANTITY\}/g, n.items[i].quantity);
          s = s.replace(/\{IMAGE\}/g, n.items[i].image+'&width=200');
          s = s.replace(/\{PRICE\}/g, Shopify.formatMoney(n.items[i].price, window.money_format));
          s = s.replace(/\{VARIANCE\}/g, n.items[i].variant_options.join(', '));
          s = s.replace(/\{KEY\}/g, n.items[i].key);
          s = s.replace(/\{TOTALPRICE\}/g, Shopify.formatMoney(n.items[i].price*n.items[i].quantity, window.money_format));
          s = s.replace(/Default Title/g, "");
          if (Object.keys(n.items[i].properties).length === 0) s = s.replace(/\{GC_DETAILS\}/g, '');
          else {
            var gcFull = '';
            var gcEmail = n.items[i].properties['Recipient email'];
            if (gcEmail != '') {
              gcFull += '<div class="gift_card_txt"><b>Recipient email:</b> '+gcEmail+'</div>';
              var gcName = n.items[i].properties['Recipient name'];
              if (gcName != '') gcFull += '<div class="gift_card_txt"><b>Recipient name:</b> '+gcName+'</div>';
              var gcMsg = n.items[i].properties['Message'];
              if (gcMsg != '') gcFull += '<div class="gift_card_txt"><b>Message:</b> '+mt.truncateString(gcMsg, 50)+'</div>';
              var gcSendOn = n.items[i].properties['Send on'];
              if (gcSendOn != '') gcFull += '<div class="gift_card_txt"><b>Send On:</b> '+gcSendOn+'</div>';
            }
            s = s.replace(/\product-inner/g, 'product-inner more-height');
            s = s.replace(/\{GC_DETAILS\}/g, gcFull);
          }
          $("#dropdown-cart .cart-list").append(s)
          $(".cart-count").removeClass('empty-cart');
          $(".cart-icon path.cart-empty").addClass('full');
        }
        /*
        $("#dropdown-cart .btn-remove").click(function(n) {
          $('#dropdown-cart').addClass('loading');
          $( ".mini_cart_header .less-than-ten" ).empty();
          //$(this).addClass('remove-cart');
          n.preventDefault();
          var cart = $(this).parents(".item").attr("id");
          cart = cart.match(/\d+/g);

          Shopify.removeItem(cart , function(e) {
            mt._headercartitem(e);
            $('#dropdown-cart').removeClass('loading');

          })
        });
        */
        if (mt._checkcurrency()) {
          if(typeof Currency != 'undefined') {
             $('#dropdown-cart span.money').each(function() {
    			$(this).attr('data-currency-'+window.shop_currency, $(this).html());
  		     });
          	 Currency.convertAll(window.shop_currency, $('.currencies_ul .currency.selected').data('currency'))
          }
        }
      }else{
        $(".cart-icon path.cart-empty").removeClass('full');
        $(".cart-count").addClass('empty-cart');
      }

      mt._quantity_control();
      mt._checkitemdropcart()
    },
    truncateString: function (str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    _quantity_control: function() {
        $(".plusminus").click(function(n) {
   
          var add_or_remove = 1;
          var control = $(this).parents('.qty-cart');
          if ($(this).hasClass('qty-minus')){
            add_or_remove = -1;
          }
          //var variant_id = $(this).parents(".item").attr("id");
          var key = $(this).parents(".item").data("key");
          var quantity_value = parseInt($(this).siblings(".cur_quantity").html(), 10)+(add_or_remove);
          //variant_id = variant_id.match(/\d+/g);

          $.ajax({
            type: "post",
            url: "/cart/change.js",
            data: "id=" + key + "&quantity=" + quantity_value,
            dataType: "json",
            beforeSend: function() {         
             control.addClass('loading');
            },
            success: function(n) {
              mt._updateheadercart();
              control.removeClass('loading');
             },
            error: function(n, r) {
              control.removeClass('loading');
              $(".ajax-error-message").text($.parseJSON(n.responseText).description);
              mt.showBox(".ajax-error-cbox");
            }
           })
  
        });
    },
    _checkcurrency: function() {
      if(typeof Currency != 'undefined')
        return window.show_multiple_currencies; //&& Currency.currentCurrency != shopCurrency
    }
  }
  $(document).ready(function(){
    $('.up-qty').click(function(){
      quantity =$('#quantity').val();
      $('#quantity').val(parseInt(quantity) + 1);
    });
    $('.down-qty').click(function(){
      quantity =$('#quantity').val();
      if(quantity > 1)
        $('#quantity').val(parseInt(quantity) - 1);
    });
  });
})(jQuery);